import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";

export const ulStyle = css`
  display: grid;

  ${MEDIA_QUERY_FOR_PC} {
    gap: 16px;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    margin-top: 40px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    gap: 8px;
    grid-template-columns: 1fr 1fr;
    margin-top: 10px;
  }
`;
